module.exports = __webpack_public_path__ + "static/img/1.440685c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncajzx/1.png
// module id = 1aOH
// module chunks = 1